import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import cookies from '../../../node_modules/@buzzfeed/bf-utils/lib/cookies/index.js';
import uuid4 from '../../../node_modules/@buzzfeed/bf-utils/lib/uuid4/index.js';
import createMemoizedFunction from '../../../node_modules/micro-memoize/dist/micro-memoize.esm.js';
import { getBaseUrl } from '../../../node_modules/@buzzfeed/bf-utils/lib/query-string/index.js';
import { getLocalCookieDomain } from '../../../node_modules/@buzzfeed/bf-utils/lib/XDomainCookies/default-domains.js';
import { getUserUUID } from '../../../node_modules/@buzzfeed/bf-utils/lib/userid/index.js';
import pageSessionIds from './page-session-ids.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
   * Creates a memoized layer function for retrieving common client metadata. The `url` value is
   * required in order to force new page session ids on url change. The url is stripped of hashes
   * to prevent new sessions from triggering on an anchor link click.
   * @param  {String} url - Full URL of the page on which the event occurred.
   * @return {Function} - A memoized layer function
   */

var commonClientMetadata = createMemoizedFunction(function (_ref) {
  var url = _ref.url;
  var sessionUuidCookieConfig = {
    name: 'bf-xdomain-session-uuid',
    days: 0.5 / 24,
    // Half hour
    domain: getLocalCookieDomain()
  };
  return createMemoizedFunction(function () {
    var client_uuid = String(getUserUUID());
    var client_session_id = cookies.get(sessionUuidCookieConfig.name, uuid4());
    cookies.set(_objectSpread(_objectSpread({}, sessionUuidCookieConfig), {}, {
      value: client_session_id
    }));
    return _objectSpread({
      /**
       * Property order is intentional and purposefully not alphabetized. Defining the shorter
       * property names and values upfront help display a useful request preview in devtools
       * which helps debugging and QA'ing the requests.
       */
      client_uuid: client_uuid,
      client_session_id: client_session_id,
      random_user_uuid: cookies.get('user_uuid', 'unauthenticated'),
      referrer_uri: document.referrer
    }, pageSessionIds(getBaseUrl(url)));
  }, {
    transformKey: JSON.stringify
  });
}, {
  /**
   * Using the base URI as the cache key stripped of query params and hashes. Otherwise, a new
   * session would be incorrectly triggered when:
   * - clicking on a section header anchor link
   * - actions on a page adds query params to the current url (using window.history.replaceState
   *   for example). Some quizes do this when results are shown, presumably to provide extra
   *   context in the event_uri value of events.
   */
  transformKey: function transformKey(_ref2) {
    var _ref3 = _slicedToArray(_ref2, 1),
        options = _ref3[0];

    return getBaseUrl(options.url);
  }
});

export default commonClientMetadata;
